export const NEXT_ROUTES_WITH_EMPTY_MILES_IDS = "nextRoutesWithEmptyMilesIds";
